import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHeader({ title, breadcrumb, actions, subtitle }) {
  return (
    <div className="mb-6">
      {breadcrumb && breadcrumb.length > 0 && (
        <nav className="flex items-center gap-1.5 text-xs text-gray-500 mb-3" aria-label="Breadcrumb">
          {breadcrumb.map((crumb, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span className="text-gray-300">/</span>}
              {crumb.href
                ? <Link to={crumb.href} className="hover:text-gray-700 transition-colors">{crumb.label}</Link>
                : <span className="text-gray-700 font-medium">{crumb.label}</span>}
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="font-display text-2xl font-bold text-gray-900 tracking-tight leading-tight">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0 flex-wrap justify-end">{actions}</div>
        )}
      </div>
    </div>
  );
}
